export { default as withBrowserHistory } from "./withBrowserHistory";
